import globalFilter from '../../../tools/globalFilter'

export default function (state, payload) {
  let selectedIds = payload.selectedItems
  return {
    ...state,
    selectedIds: selectedIds,
  }
}
